import React from "react";

type Props = { children: React.ReactNode; className?: string };

const Nofilter: React.FC<Props> = ({ className, children }) => {
  return <span className={[...([className] || []), "nofilter"].join(" ")}>{children}</span>;
};

export default Nofilter;
